import React, { useState, useContext, useMemo, useEffect } from 'react';

import { Line, Chart } from 'react-chartjs-2';
import uparrowImage from './images/uparrow8.png';
import dnarrowImage from './images/downarrow8.png';
import { UserContext } from './UserContext'
import './styles/lineChart.css'
import 'chartjs-plugin-annotation';
// import annotationPlugin from 'chartjs-plugin-annotation';


import { BsFillCaretRightFill, BsFillCaretLeftFill } from "react-icons/bs";
import { BiX } from "react-icons/bi";
import { UIcolors} from './Common'

import annotationPlugin from "chartjs-plugin-annotation";
// import datalabelsPlugin from "chartjs-plugin-datalabels";


Chart.register([annotationPlugin,]);

// defaults.global.tooltips.enabled = true // turns off tooltips when hovering over chart itself
// defaults.global.legend.position = 'bottom' //legend position top is the default
// defaults.global.legend.display = false;    //removing legends all together.  position is not needed, keeping it for reference.

var dnArrow = new Image();
dnArrow.src = dnarrowImage;

var upArrow = new Image();
upArrow.src = uparrowImage;


// showCurrentLineChart should not have any annotation also no trade stat box

const LineChart = ({ showCurrentLineChart, lineChartData, barChartLongOrShort, tradeDate0, tradeDate1, statDisplay, SetStatDisplay, saveStatDisplay, statBoxCoordinates, SetStatBoxCoordinates }) => {

    const { browserH, browserW, rdd ,loggedinUser} = useContext(UserContext)

    // default values are just for testing - not used

    const [dataClose, setDataClose] = useState([21.02, 7.92, 1.73, 3.65, 4.13, 1.36, 3.56, 5.02, 1.85, 1.17, 6.29, 24.07])

    const [labels, setLabels] = useState(['2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020'])
    const [pointStyle, setPointStyle] = useState([upArrow, dnArrow, dnArrow, upArrow, '', '', ''])

    const [x0, SetX0] = useState(0)
    const [x1, SetX1] = useState(0)
    const [y0, SetY0] = useState(0)
    const [y1, SetY1] = useState(0)
    const [tradeLineColor, SetTradeLineColor] = useState('green')
    const [tradeBoxColor, SetTradeBoxColor] = useState('rgb(255, 99, 132,0.2)')
    const [profit, SetProfit] = useState('')
    const [profitP, SetProfitP] = useState('')
    const [profitColor, SetProfitColor] = useState('rgb(0,70,0,1)')
    const [activeTrade, SetActiveTrade] = useState(false)
    const [showActive, SetShowActive] = useState('')



    const lineColorWin = 'green'
    const lineColorLose = 'red'
    const boxColorWin = 'rgb(0, 200, 0,0.1)'
    const boxColorLose = 'rgb(200, 0, 0,0.1)'
    // --------------------------------------------------------
    // useeffect for floating window
    const [boxLocation, SetBoxLocation] = useState('top-left')
    const [fBackColor, SetFBackColor] = useState('rgb(200,200,200,0.75)')

    const tmpObjL = () => {
        var tObjL = ['15%', '10.5%', '65%', '55%'];
        if (rdd.isMobile && !rdd.isTablet && browserH > browserW) tObjL = ['15%', '10.5%', '65%', '55%'] // --smartphone portrait
        else if (rdd.isMobile && !rdd.isTablet && browserH < browserW) tObjL = ['15%', '6.0%', '40%', '45%'] // --smartphone landscape
        else if (rdd.isMobile && rdd.isTablet && browserH > browserW) tObjL = ['15%', '6.0%', '40%', '45%'] // --tablet portrait
        else if (rdd.isMobile && rdd.isTablet && browserH < browserW) tObjL = ['10%', '6.0%', '35%', '40%']// --tablet landscape
        else if (!rdd.isMobile) tObjL = ['8%', '4%', '25%', '30%']// --desktop
        return tObjL
    }

    const tmpObjR = () => {
        var tObjR = ['15%', '30%', '65%', '55%'];
        var tObjL = ['15%', '10.5%', '65%', '55%']
        if (rdd.isMobile && !rdd.isTablet && browserH > browserW) tObjR = ['15%', '30%', '65%', '55%']// --smartphone portrait
        else if (rdd.isMobile && !rdd.isTablet && browserH < browserW) tObjR = ['15%', '58%', '40%', '45%']// --smartphone landscape
        else if (rdd.isMobile && rdd.isTablet && browserH > browserW) tObjR = ['15%', '58%', '40%', '45%'] // --tablet portrait
        else if (rdd.isMobile && rdd.isTablet && browserH < browserW) tObjR = ['10%', '63%', '35%', '40%']// --tablet landscape
        else if (!rdd.isMobile) tObjR = ['8%', '74%', '25%', '30%'] // --desktop
        return tObjR
    }

    const ffontSize = () => {
        var fontSize = '1vw';
        if (rdd.isMobile && !rdd.isTablet && browserH > browserW) fontSize = '4vw'// --smartphone portrait
        else if (rdd.isMobile && !rdd.isTablet && browserH < browserW) fontSize = '2.0vw'// --smartphone landscape
        else if (rdd.isMobile && rdd.isTablet && browserH > browserW) fontSize = '2.9vw' // --tablet portrait
        else if (rdd.isMobile && rdd.isTablet && browserH < browserW) fontSize = '1.7vw'// --tablet landscape
        else if (!rdd.isMobile) fontSize = '1vw' // --desktop
        return fontSize
    }


    //-------------------------------------------------
    useMemo(() => {


        var tmpDataClose = []
        var tmpDataLabel = []
        var tmpPointStyle = []

        var tmpDates = lineChartData.map((r) => { //create array of only the dates in the dataset
            return r[0]
        })

        var tmp_tradeDate0 = tradeDate0
        var tmp_tradeDate1 = tradeDate1



        var includesTradeDate0 = tmpDates.includes(tmp_tradeDate0)
        var includesTradeDate1 = tmpDates.includes(tmp_tradeDate1)

        if (!includesTradeDate0) { // if date0 not in the list, find the next date
            for (var i = 0; i < tmpDates.length; i++) {
                if (tmpDates[i] > tmp_tradeDate0) { // found it
                    tmp_tradeDate0 = tmpDates[i]
                    break;
                }
            }
        }


        if (!includesTradeDate1) { // if date1 not in the list, find the next date
            for (i = 0; i < tmpDates.length; i++) {

                // console.log('^',i,tmpDates[i] > tmp_tradeDate1)
                if (tmpDates[i] > tmp_tradeDate1) { // found it
                    tmp_tradeDate1 = tmpDates[i]
                    break;
                }
            }
        }
        var x = 0; // counting for rectangle coordinates
        var xx0 = 0, xx1 = 0

        var entryPrice = 0;
        var exitPrice = 0;
        lineChartData.forEach((r) => {

            tmpDataClose.push(r[1])
            tmpDataLabel.push(r[0]) // r[2] is volume


            switch (barChartLongOrShort) {
                case 'long':
                    if (r[0] === tmp_tradeDate0) {
                        tmpPointStyle.push(upArrow);
                        xx0 = x;
                        entryPrice = r[1]
                        let p = parseFloat(r[1]).toFixed(5).toString()
                        SetY0(p)


                    }
                    else if (r[0] === tmp_tradeDate1) {
                        tmpPointStyle.push(dnArrow);
                        xx1 = x;
                        let p = parseFloat(r[1]).toFixed(5).toString()
                        SetY1(p)
                        exitPrice = p;

                        if (r[1] - entryPrice >= 0) {
                            SetTradeLineColor(lineColorWin)
                            SetTradeBoxColor(boxColorWin)
                        }
                        else {
                            SetTradeLineColor(lineColorLose)
                            SetTradeBoxColor(boxColorLose)
                        }
                    }

                    else {
                        // SetY0(0)
                        tmpPointStyle.push('circle');
                    }
                    break;
                case 'short':
                    if (r[0] === tmp_tradeDate0) {
                        tmpPointStyle.push(dnArrow);
                        xx0 = x;
                        let p = parseFloat(r[1]).toFixed(5).toString()
                        SetY0(p)
                        entryPrice = r[1]
                    }
                    else if (r[0] === tmp_tradeDate1) {
                        tmpPointStyle.push(upArrow);
                        xx1 = x;
                        let p = parseFloat(r[1]).toFixed(5).toString()
                        SetY1(p)
                        exitPrice = r[1];
                        if (entryPrice - r[1] >= 0) {
                            SetTradeLineColor(lineColorLose);
                            SetTradeBoxColor(boxColorLose);
                        }
                        else {
                            SetTradeLineColor(lineColorWin);
                            SetTradeBoxColor(boxColorWin);
                        }
                    }
                    else {
                        // SetY0(0)
                        tmpPointStyle.push('circle');
                    }
                    break;
                default:
                    break;
            }
            x++;
        })

        SetX0(xx0);


        if (xx1 === 0) { // active trade
            SetX1(x - 1);  //active trade.  set xx1 to the last bar on the chart
            SetActiveTrade(true)
            SetShowActive('Active  ')
            if (lineChartData.length > 0) {
                let lastPriceInData = lineChartData[lineChartData.length - 1][1] //last close price in the passed data
                SetY1(lastPriceInData) //if its active set the exit price to last price in the data for calculations
                exitPrice = lastPriceInData
            }
        }
        else {
            SetX1(xx1);
            SetActiveTrade(false)
            SetShowActive('')
        }


        // console.log('xx0,xx1=',xx0,xx1)


        setDataClose(tmpDataClose)
        setLabels(tmpDataLabel)
        setPointStyle(tmpPointStyle)

        // calculate profit
        if (barChartLongOrShort === 'long') {
            var p, pp;
            if (entryPrice !== 0) {
                p = (exitPrice - entryPrice).toFixed(2);
                pp = (100 * p / entryPrice).toFixed(2);
                SetProfit(p.toString() + 'pts')
            }
            else {
                p = 0;
                pp = 0;
                SetProfit('0')
                SetY0(0)
            }





            if (pp === 0) {
                SetProfitP('')
            }

            else if (pp > 0) { // set winning colors and other things
                SetProfitP('+' + pp.toString() + '%')
                SetTradeLineColor(lineColorWin);
                SetTradeBoxColor(boxColorWin);
            }
            else { // set losing colors and other things
                SetProfitP(pp.toString() + '%')
                SetTradeLineColor(lineColorLose);
                SetTradeBoxColor(boxColorLose);
            }
            if (p >= 0) SetProfitColor('rgb(10,70,10,1');
            else SetProfitColor('rgb(215,0,0,1');
        }
        else { // its short
            p = -(exitPrice - entryPrice).toFixed(2);
            pp = (100 * p / entryPrice).toFixed(2);
            SetProfit(p.toString() + 'pts')

            if (pp > 0) SetProfitP('+' + pp.toString() + '%')
            else SetProfitP(pp.toString() + '%')

            if (p >= 0) SetProfitColor('rgb(10,70,10,1');
            else SetProfitColor('rgb(215,0,0,1');
        }

        if (statDisplay !== 'none') { // these variables should be set only when stat window is showing

            if (boxLocation === 'top-left' && statBoxCoordinates !== tmpObjL) SetStatBoxCoordinates(tmpObjL)
            else if (boxLocation === 'top-right' && statBoxCoordinates !== tmpObjR) SetStatBoxCoordinates(tmpObjR)
        }

    }, [lineChartData, boxLocation, statDisplay])




    useEffect(()=>{
        if (showCurrentLineChart) SetStatDisplay('none'); // don't show stat box if showing the current price chart
    })




    //-------------------------------------------------

    const data = {
        labels: labels,
        datasets: [
            { fill: true },
            {
                borderWidth: 1,
                pointBorderWidth: 0.1,
                data: dataClose,

                // backgroundColor: 'rgb(255, 99, 132)',
                borderColor: 'rgb(50,50,50)', // linechart color
                pointStyle: pointStyle
            },
        ],
    };
    //-------------------------------------------------
    const highlightBox = {

        drawTime: "afterDatasetsDraw",
        display: !showCurrentLineChart, // when showing the current chart don't place annotation for trade
        type: "box",
        xMin: x0,
        xMax: x1,
        // yMin: 50,
        // yMax: 97,
        backgroundColor: tradeBoxColor,
    }

    //-------------------------------------------------
    const tradeLine = {
        xMin: x0,
        xMax: x1,
        yMin: y0,
        yMax: y1,
        borderWidth: 1,
        borderDash: [5, 5],
        borderColor: tradeLineColor,
        display: !activeTrade
    }

    //-------------------------------------------------
    let axisFontSize = '20vw';
    let caretSize = '25';

    if (rdd.isMobile && !rdd.isTablet && window.innerHeight > window.innerWidth) { // smartphone portrait
        axisFontSize = '14vw';
        caretSize = '22';
    }
    else if (rdd.isMobile && !rdd.isTablet && window.innerHeight < window.innerWidth) { //smartphone landscape
        axisFontSize = '18vw';
        caretSize = '25'
    }
    else if (rdd.isMobile && rdd.isTablet && window.innerHeight > window.innerWidth) { // tablet portrait
        if (window.innerHeight > 1024) {
            axisFontSize = '15vw';
            caretSize = '35'
        }
        else axisFontSize = '12vw';
    }
    else if (rdd.isMobile && rdd.isTablet && window.innerHeight < window.innerWidth) { //tablet landscape
        axisFontSize = '12vw';
    }
    else if (!rdd.isMobile) {                                       // desktop
        axisFontSize = '10vw';
        caretSize = '20';
    }

    const options = {
        maintainAspectRatio: false,
        scales: {
            x: { ticks: { font: { size: axisFontSize }, }, },
            y: { beginAtZero: false, ticks: { font: { size: axisFontSize }, }, }
        },
        // showLine:false,
        plugins: {
            legend: { display: false },
            annotation:
            {
                display: false,
                annotations: {
                    box1: highlightBox,
                    line1: tradeLine,

                }
            }
        }
    };

    //---------------------------------------

    const lArrowClicked = (event) => {
        SetBoxLocation('top-left');
    }
    //---------------------------------------
    const rArrowClicked = (event) => {
        SetBoxLocation('top-right');
    }

    const handleCloseStat = (event) => {
        SetStatDisplay('none');
        saveStatDisplay('none'); // this sets a cookie in stockLineChart.js
    }

    //---------------------------------------
    //   0    1    2      3
    // [top,left,width,height]
    const fWindowStyle = {
        width: statBoxCoordinates[2],
        height: statBoxCoordinates[3],
        top: statBoxCoordinates[0],
        left: statBoxCoordinates[1],
        fontSize: ffontSize,
        fontWeight: '600',
        display: statDisplay,

        backgroundColor: fBackColor,
        border: '1px solid rgb(0,0,250,0.2)',

    }
    //---------------------------------------
    const fLeftArrowStyle = {
        // display: arrowDisp['left'],
        fill: 'white'
    }
    const fRightArrowStyle = {
        // display: arrowDisp['right'],
        fill: 'white'
    }

    //------------------------------------------------------------------------------------------
    return (
        <div style={{ backgroundColor:UIcolors(loggedinUser)['background_price_chart'] , height: "100%" }}>

            {/* floating window section */}
            <div className='f-parent' style={fWindowStyle} >
                <div className='f-row-title' style={{ backgroundColor: 'rgb(200,0,0,0.2)' }}>
                    <div className='title-left' onClick={lArrowClicked} >
                        {boxLocation === 'top-left'
                            ? <BiX size={caretSize} style={fLeftArrowStyle} onClick={handleCloseStat} />
                            : <BsFillCaretLeftFill size={caretSize} style={fLeftArrowStyle} />
                        }
                    </div>

                    <div className='title-center'><span style={{ color: 'red', paddingRight: '2px' }}>{showActive}</span>Trade Stats</div>
                    <div className='title-right' onClick={rArrowClicked} >

                        {boxLocation === 'top-right'
                            ? <BiX size={caretSize} style={fLeftArrowStyle} onClick={handleCloseStat} />
                            : <BsFillCaretRightFill size={caretSize} style={fRightArrowStyle} />
                        }
                    </div>
                </div>
                <div className='f-row'>
                    <div className='f-cell-left f-row-A'>Trade Dir</div>
                    <div className='f-cell-right f-row-A'>{barChartLongOrShort}</div>
                </div>
                <div className='f-row'>
                    <div className='f-cell-left f-row-B'>Entry Price</div>
                    <div className='f-cell-right f-row-B'>{y0}</div>
                </div>
                <div className='f-row'>
                    {activeTrade === true
                        ? <div className='f-cell-left f-row-A'>Current Price</div>
                        : <div className='f-cell-left f-row-A'>Exit Price</div>
                    }
                    <div className='f-cell-right f-row-A'>{y1}</div>
                </div>
                <div className='f-row'>
                    <div className='f-cell-left f-row-B'>profit</div>

                    <div className='f-cell-right f-row-B' style={{ color: profitColor }}>{profit}  {profitP}</div>
                </div>
            </div>
            {/* end floating window section */}

            <div style={{ height: '100%', width: '100%' }}>
                <Line data={data} options={options} />
            </div>
        </div>
    )
}

export default LineChart
